<lms-breadcrumb [label]="'games.create'"></lms-breadcrumb>
<lms-game-editor (saved)="onSave($event)">
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="cancel()" form-actions-before></gl-button>
</lms-game-editor>
